// extracted by mini-css-extract-plugin
export default {"container":"LgpYo0KJ","mobile":"mobile","link":"QvJ_1yAt","desktop":"desktop","_active":"NXUUkfaA"};